//Auth Slice
export const SELLER_VERIFICATION = 'SELLER_VERIFICATION'
export const SELLER_REGISTER = 'SELLER_REGISTER'
export const SELLER_LOGIN = 'SELLER_LOGIN'
export const SELLER_LOGOUT = 'SELLER_LOGOUT'
export const SELLER_FORGOTPASSWORD = 'SELLER_FORGOTPASSWORD'
export const SELLER_RESETPASSWORD = 'SELLER_RESETPASSWORD'
// export const SELLER_VIEW_PROFILE_DETAILS = "SELLER_VIEW_PROFILE_DETAILS"
//GST Slice
export const SELLER_GSTDETAILS = 'SELLER_GSTDETAILS'
export const SELLER_PICKUPADDRESS = 'SELLER_PICKUPADDRESS'
export const SELLER_BANKDETAILS = 'SELLER_BANKDETAILS'
export const SELLER_SUPPLIERDETAILS = 'SELLER_SUPPLIERDETAILS'
export const SELLER_GETSTEPS = 'SELLER_GETSTEPS'
//City-State Slice
export const SELLER_CITY = 'SELLER_CITY'
export const SELLER_STATE = 'SELLER_STATE'
export const SELLER_COUNTRY = 'SELLER_COUNTRY'
//Seller Settings
export const SELLER_EDITPROFILE = 'SELLER_EDITPROFILE'
export const SELLER_VIEWPROFILE = 'SELLER_VIEWPROFILE'
export const SELLER_CHANGEPASSWORD = 'SELLER_CHANGEPASSWORD'
//Seller Catalogs Add Upload
export const SELLER_MATERIAL = 'SELLER_MATERIAL'
export const SELLER_TYPE = 'SELLER_TYPE'
export const SELLER_COLOR = 'SELLER_COLOR'
export const SELLER_SIZE = 'SELLER_SIZE'
export const SELLER_GETMAINCATEGORY = 'SELLER_GETMAINCATEGORY'
export const SELLER_GETCATEGORY = 'SELLER_GETCATEGORY'
export const SELLER_GETSUBCATEGORY = 'SELLER_GETSUBCATEGORY'
export const SELLER_ADDPRODUCT = 'SELLER_ADDPRODUCT'
export const SELLER_TIME = "SELLER_TIME"
export const SELLER_VIEWPRODUCTVARIANT = 'SELLER_VIEWPRODUCTVARIANT'
export const SELLER_LISTPRODUCT = 'SELLER_LISTPRODUCT'
export const ADD_SUBCATEGORYLISTDATA = "ADD_SUBCATEGORYLISTDATA"
export const ADD_MATERIAL_LIST_DATA = "ADD_MATERIAL_LIST_DATA"
export const ADD_PRODUCT_TYPE_DATA = "ADD_PRODUCT_TYPE_DATA"
export const ADD_PRODUCT_COLOR_DATA = "ADD_PRODUCT_COLOR_DATA"
export const VIEW_CATALOG_DATA_LIST = "VIEW_CATALOG_DATA_LIST"
export const UPDATE_ADD_VARIANT_DATA = "UPDATE_ADD_VARIANT_DATA"
export const DELETE_CATALOG_IMAGE = "DELETE_CATALOG_IMAGE"
export const DELETE_VIEW_PRODUCT_VARIANT_DATA = 'DELETE_VIEW_PRODUCT_VARIANT_DATA'
export const DELETE_WHOLE_CATALOG_DATA = "DELETE_WHOLE_CATALOG_DATA" 
// Inventory Data Action
export const PAUSE_INVENTORY_LIST_DATA ="PAUSE_INVENTORY_LIST_DATA"





